import React from 'react';
import withLifecycles from 'async-lifecycles';
import {Button, Form, Header} from 'semantic-ui-react';
import produce from 'immer';

import {FormWrapper, Wrapper} from './Layout';
import {FormattedMessage} from '../i18n/Context';
import api from '../../store/services/api';
import {ErrorMessages} from '../form-components/ErrorMessages';

class CompleteRegistration extends React.Component {
  state = {
    loading: false,
    error: {},
    password: '',
    confirmPassword: '',
  };
  _mutateState = mutationFn => {
    this.setState(produce(mutationFn));
  };
  _handleInputChanged = (event, {name, value}) => {
    this._mutateState(state => {
      state[name] = value;
    });
  };

  _completeRegistration = () => {
    withLifecycles(
      () => {
        const {token} = this.props.match.params;
        const {password, confirmPassword} = this.state;
        return api.patch(`/accounts/registration/complete/${token}`, {
          password,
          confirmPassword,
        });
      },
      ({loading, data, error}) => {
        this.setState({loading, data, error});
        if (data && !data.hasErrors) {
          this.props.history.replace('/account/login');
        }
      },
    );
  };

  render() {
    const {loading, error, password, confirmPassword} = this.state;
    return (
      <Wrapper>
        <Header textAlign="center">
          <img
            src={`${process.env.PUBLIC_URL}/mm_logo.png`}
            alt="M&M International"
          />
        </Header>
        <FormWrapper attached loading={loading}>
          <Header textAlign="center">
            <FormattedMessage id="completeRegistration.form.header" />
          </Header>
          <Form onSubmit={this._completeRegistration}>
            <Form.Field>
              <FormattedMessage id="completeRegistration.form.password" />
              <Form.Input
                type="password"
                name="password"
                value={password}
                onChange={this._handleInputChanged}
                autoFocus
              />
            </Form.Field>
            <Form.Field>
              <FormattedMessage id="completeRegistration.form.confirmPassword" />
              <Form.Input
                type="password"
                name="confirmPassword"
                value={confirmPassword}
                onChange={this._handleInputChanged}
              />
            </Form.Field>
            <Button type="submit" primary fluid>
              <FormattedMessage id="completeRegistration.form.button.submit" />
            </Button>
          </Form>
          <ErrorMessages error={error} />
        </FormWrapper>
      </Wrapper>
    );
  }
}

export default CompleteRegistration;
